import React from 'react';
import axios2 from 'services/axios2';
import { ToastContainer, toast } from 'react-toastify';
import ImageUploadSingle from "components/nubox/ImageUploadSingle";

import { withRouterJim } from "router/withRouterJim"; 

import { Link } from "react-router-dom";
//import '../App.css';
import logo from 'assets/logo.png';

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Configd extends React.Component {

  myRef = React.createRef();//create ref
  citaRef = React.createRef();//create ref

  state = {
    data: [],/* lista  */
    form: {
      id_mate:0,
      foto_path: "",
      
    },
    medicos: [],
  };

  //-----------------------------------------------

  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount citas");
    //--limpiamos el array de prueba
    this.setState({ data: [] });

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //this.setState({fechai: defaultValue}); 
    //let id_mate = this.props.store.materia.id_mate
    this.setState({ form: { ...this.state.form, 
                            fecha: defaultValue, 
    
                  } });

    
    this.cargar_data();
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);


  }

  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  onSubmitHandler= (event)=>{
    event.preventDefault();

    this.save();
  }
  //====================================================== 
  cargar_data = () => {
    let id_mate = this.props.store.materia.id_mate

    let param = { 
      id_mate: id_mate
    }
    
    axios2.post( 'configd_get_obj', param)
    .then(res => {
        console.log(res.data);
        //if(res.data.length>0){ 
            this.setState({form: res.data});
        //}else{
            //NotificationManager.error('No existen datos');
        //}

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //====================================================== 
  /************************************************ */
  okImage = (filename) =>{    
    this.setState({ form:{...this.state.form,foto_path : filename}}); 
  }
  cancelImage = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, foto_path: '' }}); 
  }
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;

    let param = {...this.state.form,
                };
    console.log(param);
    axios2.post("configd_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            toast.success(res.data.men);            
        }else{
            toast.error(res.data.men);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------

  render() {
    let form = this.state.form
    let user = this.props.store.user
    return (
      <div>
        <ToastContainer />
        <div className="content">
          {
            JSON.stringify(this.state.form)
          }
          <form onSubmit={ this.onSubmitHandler}> 
            
              <legend>Configuracion materia</legend>

              <div className="alert alert-info">
                <strong>Nota:</strong> 
              </div>
              <div className='card' style={{ width:500 }}>
                <div className="table-responsive">
                  <table className="table">
                    <tbody><tr>
                      <td>
                        <label>IMAGEN:</label>
                      </td>
                      <td>
                        <ImageUploadSingle
                          okImage={this.okImage}
                          cancelImage={this.cancelImage}
                          API_URL={ process.env.REACT_APP_API_URL }
                          imageURL={ process.env.REACT_APP_AFILES }
                          fileName={ this.state.form.foto_path }
                          withImage="150px"
                        />
                      </td>
                    </tr>

                      <tr>
                        <td>
                          <label>Codigo:</label>
                        </td>
                        <td>{ form.id_mate }
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label>Materia:</label>
                        </td>
                        <td>{ form.nombre}
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label>Docente:</label>
                        </td>
                        <td>{ user.nomape }
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label>Grupo:</label>
                        </td>
                        <td>{ form.id_grupo}
                          
                        </td>
                      </tr>
                    </tbody>
                    </table>
                </div>

                <div className='card-footer' align="center">
                  <input 
                    className="btn btn-primary" 
                    type="submit" 
                    value="Guardar"
                  />
                </div>
              </div>
              
            
          </form>
          <br/>

        </div>


      </div>
    );
  }
}

export default withRouterJim(Configd);